import { render } from "./OapCard.vue?vue&type=template&id=182e914e&scoped=true"
import script from "./OapCard.vue?vue&type=script&lang=js"
export * from "./OapCard.vue?vue&type=script&lang=js"

import "./OapCard.vue?vue&type=style&index=0&id=182e914e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182e914e"]])

export default __exports__